module.exports = __webpack_public_path__ + "assets_1789460829583/img/pic_6.13790e82.png";